<template>
  <b-modal title="Create client" :visible="true" @ok="myModal = false" @hidden="$emit('hidden')" @hide="stop" ref="createClientModal">
    <b-form @submit.prevent="createClient()">
      <b-form-group
        label="Name"
        label-for="clientName"
        :label-cols="2"
        :horizontal="true">
        <b-form-input id="clientName" type="text" autocomplete="name" v-model="client.name" @keypress.native="error = null"></b-form-input>
      </b-form-group>
      <b-form-group
        label="Email"
        label-for="clientEmail"
        :label-cols="2"
        :horizontal="true">
        <b-form-input id="clientEmail" type="email" autocomplete="email" v-model="client.email" @keypress.native="error = null"></b-form-input>
      </b-form-group>
      <b-form-group
        label="Phone"
        label-for="clientPhone"
        :label-cols="2"
        :horizontal="true">
        <b-form-input id="clientPhone" type="text" autocomplete="name" v-model="client.phone" @keypress.native="error = null"></b-form-input>
        <button type="submit" hidden/>
      </b-form-group>
    </b-form>
    <transition name="fade">
      <b-alert show variant="danger" style="width: 100%;" v-if="error">{{error.message}}</b-alert>
    </transition>
    <div slot="modal-footer">
      <b-button type="button" variant="success" class="ladda-button" id="create-button" data-style="expand-right" @click="createClient()"><i class="fa fa-plus"></i>&nbsp;Create client</b-button>
    </div>
  </b-modal>
</template>

<script>
import * as Ladda from 'ladda'
import api from '../../api'
import config from '../../config'

export default {
  name: 'CreateClient',
  data () {
    return {
      client: {
        name: null,
        email: null,
        phone: null
      },
      creatingClient: false,
      createButton: null,
      error: null
    }
  },
  mounted: function() {
    // console.log(this)
    // console.log(this.$refs.createClientModal._data.is_visible)
    this.$refs.createClientModal._data.is_visible = true
    // this.$refs.createClientModal.show()
    this.createButton = Ladda.create(document.querySelector( '#create-button' ))
  },
  methods: {
    createClient: function() {
      this.creatingClient = true
      this.createButton.start()
      api.request('post', config.serverURI + 'clients', this.client)
        .then(response => {
          this.creatingClient = false
          this.createButton.stop()
          this.$emit('created',response.data)
          this.$refs.createClientModal.hide()
        })
        .catch(error => {
          this.creatingClient = false
          this.createButton.stop()
          if (error.response) {
            this.error = {
              message: error.response.data.error
            }
          } else {
            this.error = {
              message: 'Server error!'
            }
          }
        })
    },
    stop: function(event) { //prevents modal close while waiting for the API response
      if (this.creatingClient) event.preventDefault()
    }
  }
}
</script>

<style scoped>
  .fade-enter-active {
    transition: all .8s ease;
  }
  .fade-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    /* transform: translateX(10px); */
    opacity: 0;
  }
</style>